import React from 'react';
import EmptyStateBase from '@alltrails/shared/components/EmptyStateBase';
import Button from '@alltrails/shared/denali/components/Button';

import * as styles from './styles/styles.module.scss';
import empty from '../icons/empty.svg';

const title = 'No results found';
const subText = `Let's get you back on track! Try adjusting your filters or search for a trail or property.`;

type EmptyStateProps = {
  onResetFilters: () => void;
};

const NullState = ({ onResetFilters }: EmptyStateProps): JSX.Element => (
  <div className={styles.emptyState}>
    <EmptyStateBase
      className={styles.emptyStateContent}
      icon={<img src={empty} alt="No results found" />}
      title={title}
      subText={subText}
      cta={<Button text="Clear filters" className={styles.emptyStateReset} onClick={onResetFilters} testId="Clear filters" variant="primary" />}
    />
  </div>
);

export default NullState;
